import React, { useRef, useEffect, useState } from "react";

import useHttp from "../../../../hooks/use-http";
import convertToExcel from "../../../../components/ExportToExcel";
import Pagination from "../../../../components/Pagination";
import { AutoComplete } from "antd";
import { useNavigate } from "react-router-dom";

const NurseryReport = () => {
  const frmRef = useRef({});
  const navigate = useNavigate();
  const handleButtonClick = () => {
    navigate("/farmerwise");
  };
  const [employeeId, setEmployeeId] = useState(0);
  const [employeeData, setEmployeeData] = useState([]);
  const [employeeAllData, setEmployeeAllData] = useState([]);
  const [regionId, setRegionId] = useState();
  const [regionData, setRegionData] = useState([]);

  const [nurseryGroupId, setNurseryGroupId] = useState(0);
  const [nurseryData, setNurseryData] = useState([]);

  const [identificationNumber, setIdentificationNumber] = useState();

  const [identificationData, setIdentificationData] = useState();

  const [showDateFilter, setShowDateFilter] = useState(false);

  const handleDateFilterChange = (e) => {
    setShowDateFilter(e.target.value === "Yes");
  };

  const [data, setData] = useState([]);

  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const { sendRequest: getWarehouseData } = useHttp();

  const handleFDateChange = (e) => {
    setSelectedFromDate(e.target.value);
  };
  const handleTDateChange = (e) => {
    setSelectedToDate(e.target.value);
  };

  // var date =date.setDate(date.getDate() + 10);

  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  d.setDate(d.getDate() - 30);

  const fromDate = d.toISOString().slice(0, 10);
  const [selectedFromDate, setSelectedFromDate] = useState(fromDate);

  const toDate = new Date().toISOString().slice(0, 10);

  const [selectedToDate, setSelectedToDate] = useState(toDate);

  const { sendRequest: getprocurementData } = useHttp();

  const fillprocurementData = (
    employeeId,
    regionId,
    identificationNumber,
    nurseryGroupId
  ) => {
    var urlfilter = "";

    if (showDateFilter) {
      urlfilter = urlfilter + `&fromDate=${selectedFromDate}`;
      urlfilter = urlfilter + `&toDate=${selectedToDate}`;
    }

    if (employeeId > 0) {
      urlfilter = urlfilter + `&fieldExecutiveId=${employeeId}`;
    }
    if (nurseryGroupId > 0) {
      urlfilter = urlfilter + `&nurseryGroupSiteId=${nurseryGroupId}`;
    }

    if (regionId > 0) {
      urlfilter = urlfilter + `&regionId=${regionId}`;
    }
    if (identificationNumber != "") {
      urlfilter = urlfilter + `&identificationNo=${identificationNumber}`;
    }

    var url = `/api/farmerNurseryReport/?orgId=${localStorage.getItem(
      "orgId"
    )}${urlfilter} `;

    getprocurementData(
      {
        url: url,
      },
      (data) => {
        setData(data);
      }
    );
  };

  useEffect(() => {
    fillprocurementData(0, 0, "", 0);
  }, [getprocurementData]);

  const fieldsToExport = [
    "registrationDate",
    "farmerName",
    "farmerNo",
    "executiveName",
    "regionName",
    "gender",
    "dob",
    "mobile",
    "email",
    "address",
    "pinCode",
    "city",
    "state",
    "country",
    "farmerEducation",
    "idProof",
    "totalLand",
    "totalLandUnit",
    "farmerGroup",
    "institute",
    "caste",
    "farmerIncome",
    "typeOfLandOwnership",
    "typeOfFarming",
    "farmerOtherIncome",
    "farmerGoal",
    "fpoCertificate",
    "fpoCertificateQuantity",
    "fpoCertificateAmount",
    "otherShares",
    "otherSharesQuantity",
    "accountNumber",
    "accountHolderName",
    "ifscCode",
    "training",
  ];

  const customHeaders = [
    "Registration Date",
    "Farmer Name",
    "Farmer No",
    "Executive Name",
    "Region Name",
    "Gender",
    "DOB",
    "Mobile",
    "Email",
    "address",
    "Pincode",
    "City ",
    "State",
    "Country ",
    "farmerEducation",
    "Id Proof",
    "Total Land",
    "Total Land Unit",
    "Farmer Group",
    "Institute",
    "Caste",
    "Farmer Income",
    "Type Of Land Ownership",
    "Type Of Farming",
    "Farmer Other Income",
    "Farmer Goal",
    "FPO Certificate ",
    "FPO Certificate Quantity",
    "FPO Certificate Amount ",
  ];

  const handleExportExcel = () => {
    const filename = "FarmerDetail.xlsx";

    convertToExcel(data, fieldsToExport, filename, customHeaders);
  };

  const { sendRequest: getEmp } = useHttp();

  const EmployeeDetail = (region) => {
    var urlfilter = "";

    if (region > 0) {
      urlfilter = urlfilter + `&regionId=${region}`;
    }
    getEmp(
      {
        url: `/api/fillEmployeeForReortwithCase/?useCase=Procurement&empId=${localStorage.getItem(
          "empId"
        )}&orgId=${localStorage.getItem("orgId")}${urlfilter} `,
      },
      (data) => {
        console.log("emp", data);
        var emplist = data;

        setEmployeeData(emplist);
        setEmployeeAllData(emplist);
      }
    );
  };

  useEffect(() => {
    EmployeeDetail(0);
  }, [getEmp]);

  const { sendRequest: getRegion } = useHttp();
  useEffect(() => {
    getRegion(
      {
        url: `/api/procurementRegionList/?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        setRegionData(data.data);
      }
    );
  }, [getRegion]);

  const { sendRequest: getNursery } = useHttp();
  useEffect(() => {
    getNursery(
      {
        url: `/api/nurserygroupsite/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          setNurseryData(res);
        }
      }
    );
  }, [getNursery]);

  const { sendRequest: getIdentificationNumber } = useHttp();
  useEffect(() => {
    getIdentificationNumber(
      {
        url: `/api/farmerIdentificationlist/?orgId=${localStorage.getItem(
          "orgId"
        )}&fieldExecutiveId=${employeeId}`,
      },
      (data) => {
        setIdentificationData(data);
      }
    );
  }, [employeeId]);

  const handleSearch = (value) => {
    setIdentificationNumber(value);
  };

  // const options = identificationData&&identificationData.map(item => ({ value: item.identificationNo }));

  const filteredOptions =
    identificationData &&
    identificationData
      .filter((item) => item.identificationNo.includes(identificationNumber))
      .map((item) => ({ value: item.identificationNo }));

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          {" "}
          <div className="col-md-8 mt-3">
            {" "}
            <label className="card-title mx-3">Nurseries Detail Reports</label>
          </div>
          <div className="col-md-4 text-right mt-3">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={handleButtonClick}
            >
              <i className="fas fa-times" />
            </button>
          </div>
        </div>
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  <label>Region</label>
                  <select
                    id="regionId"
                    className="form-control"
                    ref={(el) => (frmRef.current["regionId"] = el)}
                    value={regionId}
                    onChange={(e) => {
                      var regid = 0;

                      if (e.target.value != "--Select--") {
                        regid = e.target.value;
                      }
                      setRegionId(regid);
                      EmployeeDetail(regid);
                      setEmployeeId(0);
                      setData([]);
                    }}
                  >
                    <option value="">Select</option>
                    {regionData &&
                      regionData.map((x) => (
                        <option
                          key={x.regionId}
                          user-id={x.regionId}
                          value={x.regionId}
                        >
                          {x.regionName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor={"executive_officer"}>
                    {"Procurement Officer"}
                  </label>
                  <select
                    id="emp_id"
                    className="form-control"
                    ref={(el) => (frmRef.current["emp_id"] = el)}
                    value={employeeId}
                    onChange={(e) => {
                      var userid = 0;
                      if (e.target.value != "--Select--")
                        userid = e.target.value;

                      setEmployeeId(userid);
                      setData([]);
                    }}
                  >
                    <option value="0">Select</option>
                    {employeeData &&
                      employeeData.map((x) => (
                        <option
                          key={x.userId}
                          user-id={x.userId}
                          value={x.userId}
                        >
                          {x.employeeName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor={"nursery_group"}>{"Nursery Group"}</label>
                  <select
                    id="nursery_group"
                    className="form-control"
                    ref={(el) => (frmRef.current["nursery_group"] = el)}
                    value={nurseryGroupId}
                    onChange={(e) => {
                      setNurseryGroupId(e.target.value);
                    }}
                  >
                    <option value="0">Select</option>
                    {nurseryData &&
                      nurseryData.map((x) => (
                        <option
                          key={x.nurseryGroupSiteId}
                          value={x.nurseryGroupSiteId}
                        >
                          {x.nurseryGroupSiteName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <label htmlFor="identification_number">
                  Identification Number
                </label>
                <AutoComplete
                  className="form-control"
                  style={{ width: "200px", height: "30px" }}
                  value={identificationNumber}
                  options={filteredOptions}
                  placeholder="Identification Number"
                  onChange={handleSearch}
                />
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  {" "}
                  <label htmlFor={"date_filter"}>{"Apply Date Filter"}</label>
                  <select
                    id="date_filter"
                    className="form-control"
                    ref={(el) => (frmRef.current["date_filter"] = el)}
                    onChange={handleDateFilterChange}
                  >
                    <option value="">Select</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>
              </div>
              {showDateFilter && (
                <>
                  <div className="col-md-3">
                    <div className="form-group">
                      {" "}
                      <label htmlFor={"from_date"}>{"From Date"}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        // ref={(el) => (frmRef.current["pdate"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedFromDate}
                        onChange={handleFDateChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label htmlFor={"to_date"}>{"To Date"}</label>

                      <input
                        type={"date"}
                        id={"date"}
                        required
                        // ref={(el) => (frmRef.current["pdate"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedToDate}
                        onChange={handleTDateChange}
                      />
                    </div>
                  </div>
                </>
              )}
              <div className="col-md-3  text-right">
                <div className="form-group">
                  <label>&nbsp;</label>
                  <button
                    className="form-control btn btn-sm btn-primary"
                    onClick={(e) => {
                      fillprocurementData(
                        employeeId,
                        regionId,
                        identificationNumber,
                        nurseryGroupId
                      );
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
          <h5>Please select the parameters to get the desired result</h5>
          <hr />
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="text-right my-2">
              <button
                type="button"
                className="btn btn-sm btn-warning"
                onClick={handleExportExcel}
              >
                <i className="fas fa-file-excel"></i>
              </button>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <table className="table table-bordered table-responsive text-center table-sm">
                      <thead>
                        <tr className="table-header">
                          <th>Farmer Name</th>
                          <th>Identification No</th>
                          <th>Farmer No</th>
                          <th>Executive Name</th>
                          <th> Region Name</th>
                          <th>Nursery Date</th>
                          <th>Target Nurseries</th>
                          <th> Type Of Nusery</th>
                          <th> Group Name</th>
                          <th> Crop</th>
                          <th> Variety</th>
                          <th> Number Of Beds</th>
                          <th> Number Of Beds Prepared</th>
                          <th>Number Of BedsSown </th>
                          <th> Nursery Sowing Date</th>
                          <th> Nurseries Germinated Beds </th>
                          <th> Remark</th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => {
                            return (
                              <tr key={i} className="tablerowview">
                                <td>{itm.farmerName}</td>
                                <td>{itm.identificationNo}</td>
                                <td>{itm.farmerNo}</td>
                                <td>{itm.fieldExecutiveName}</td>

                                <td>{itm.regionName}</td>
                                <td>{itm.date}</td>
                                <td>{itm.targetNurseries}</td>
                                <td>
                                  {itm.individual ? "Individual" : "Group"}
                                </td>

                                <td>{itm.groupName}</td>
                                <td>{itm.cropName}</td>

                                <td> {itm.cropVariety} </td>
                                <td> {itm.numberOfBeds} </td>
                                <td> {itm.numberOfBedsPrepared} </td>
                                <td> {itm.numberOfBedsSown} </td>
                                <td> {itm.nurserySowingDate} </td>
                                <td> {itm.nurseriesGerminatedBeds} </td>

                                <td> {itm.remark} </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>

                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default NurseryReport;
